import { render } from "./PugModal.vue?vue&type=template&id=0a701c22"
const script = {}

import exportComponent from "D:\\a\\1\\s\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.5.11_vue@3.5.11_webpack@5.95.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__